var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-check"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check",
    clipPath: "url(#clip-icon-check)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M688.871,961.129c-96.335,0-174.71-78.375-174.71-174.71S592.536,611.71,688.871,611.71s174.71,78.374,174.71,174.709S785.206,961.129,688.871,961.129Zm0-293.419a118.71,118.71,0,1,0,118.71,118.709A118.844,118.844,0,0,0,688.871,667.71Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M681.516,876.737a28,28,0,0,1-21.062-9.55l-51.871-59.221a28,28,0,1,1,42.125-36.9l29.68,33.885,54.24-68.774A28,28,0,0,1,778.6,770.855l-75.1,95.221a28,28,0,0,1-21.264,10.653Q681.877,876.737,681.516,876.737Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M516.613,959.581H231.807a73.082,73.082,0,0,1-73-73V137.355a73.082,73.082,0,0,1,73-73H790.581a73.083,73.083,0,0,1,73,73v479.9a28,28,0,0,1-56,0v-479.9a17.019,17.019,0,0,0-17-17H231.807a17.019,17.019,0,0,0-17,17V886.581a17.019,17.019,0,0,0,17,17H516.613a28,28,0,0,1,0,56Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M478.937,532.8V323.962q-58.295,44.751-78.486,44.751-9.639,0-17.1-7.688a24.769,24.769,0,0,1-7.459-17.786q0-11.7,7.344-17.212T409.171,311.8q27.765-13.082,44.407-27.539a188.052,188.052,0,0,0,29.49-32.359q12.849-17.9,16.753-22.031t14.688-4.131a23.522,23.522,0,0,1,19.507,9.409q7.341,9.414,7.343,25.933V523.85q0,46.128-31.441,46.128-14,0-22.49-9.41T478.937,532.8Z",
    fill: "#2092bc",
    stroke: "#2092bc",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.fd15e813f278a038f1bd0c9d759c1dd2.svg";
export { ForwardRef as ReactComponent };